const getters = {
	nowLangx: state => state.customLang,
	langxList: state => state.langList,
	defLangx: state => state.defaultLang,
	loadingState: state => state.isLoadingShow
}

export default getters